export default {
  newTitle: 'Nova Simulação de Orçamento',
  create: 'Criar',
  name: 'Nome',
  startDate: 'Data de Início',
  endDate: 'Data de Término',
  mixMode: 'Modo do Mix',
  free: 'Livre',
  frozen: 'Fixo',
  freeDesc: 'O otimizador escolhe o melhor mix em cada orçamento (um Plan Optimizer por orçamento).',
  frozenDesc: 'Cada orçamento mantém o mix informado abaixo (um Plan Calculator por orçamento).',
  budgetGrid: 'Grade de Orçamentos',
  referenceBudget: 'Orçamento de referência (100%)',
  useHistoricalBudget: 'Usar o gasto histórico ({value})',
  minPct: 'De',
  maxPct: 'Até',
  points: 'Pontos',
  mixTitle: 'Mix de Mídia',
  useHistoricalMix: 'Usar mix histórico',
  total: 'Total',
  mixMustAddUp: 'As proporções devem somar 100%.',
  frozenTimeHint: 'Cada mídia distribui seu orçamento no período seguindo seu próprio padrão histórico de gasto nos mesmos meses (ou semanas).',
  nameRequired: 'O nome é obrigatório',
  mustBeAfterStartDate: 'Deve ser posterior à data de início',
  maxAboveMin: 'Deve ser maior que o início da grade',
  noPeriods: 'O período selecionado não tem períodos do modelo.',
  gridTooSmall: 'A grade precisa de pelo menos 2 orçamentos diferentes.',
  createFailed: 'Não foi possível criar a simulação de orçamento. Tente novamente.',
  editTitle: 'Editar Simulação de Orçamento',
  save: 'Salvar',
  editWarning: 'Ao salvar, todos os orçamentos da grade são recalculados do zero.',
  namePlaceholder: 'ex. Cenários de orçamento 2027',
  pickDate: 'Escolha uma data',
  pickMode: 'Escolha como o mix é definido em cada orçamento',
  modelRange: 'Dados do modelo: {from} → {to}',
  periodMonths: '{count} mês | {count} meses',
  periodWeeks: '{count} semana | {count} semanas',
  setupFirst: 'Escolha o modo do mix e o período para configurar a grade de orçamentos.',
  historicalSpendHint: 'O gasto histórico do período',
  typeAmountHint: 'Digite um valor, como 500k ou 2m',
  ofReference: 'da referência',
  pointsHint: 'Orçamentos a simular, até {max}',
  gridPreview: '{count} orçamentos a simular',
  mixIntro: 'Proporção de cada orçamento por mídia',
  historicalShort: 'Histórico {value}%',
  referenceRequired: 'Digite um orçamento de referência maior que 0.'
}
